<template>
  <div>
    <cabecalho titulo="Sobre o grupo de pesquisa"></cabecalho>
    <div class="container-fluid text-justify mb-4">
        <h2><em>Alumni</em> - Grupo interdisciplinar de estudos e pesquisas sobre carreira e Egressos</h2>
      <p class="text-center">
        <a href="https://alumniufmg.blogspot.com" target="blank"><img src="@/assets/alumni.png" alt="" height="80"></a>
        <a href="http://dgp.cnpq.br/dgp/espelhogrupo/267623" target="blank"><img src="@/assets/diretorio_grupos.png" alt="" height="80"></a>
      </p>
      
      <p><em>Alumni</em>, termo utilizado para nomear o grupo, é a forma pluralizada de alumnus (egresso, ex-aluno), palavra de origem latina que tinha o significado de “filho que é dado a cuidado de outro”, referindo-se, em uma interpretação mais romântica, ao indivíduo que é “alimentado com conhecimento”. O grupo tem por objetivo desenvolver estudos que se organizam a partir de dois eixos: 1) pesquisas com os Egressos dos Programas de Graduação e Pós-Graduação da Universidade Federal de Minas Gerais (UFMG); 2) pesquisas psicossociais sobre as carreiras profissionais e acadêmicas. O acompanhamento dos Egressos, além de manter aberto o contato com este segmento, proporcionando conhecimento sobre as trajetórias, atuação e inserção no mercado, permite levantar informações para a (re)elaboração dos cursos e suas políticas educacionais, uma vez que os indicadores sobre a atuação ocupacional dos Egressos são um dos novos critérios de avaliação adotado pela Coordenação de Aperfeiçoamento de Pessoal de Nível Superior (CAPES). Entende-se que se aproximar dos Egressos é pesquisar sobre as suas carreiras, considerando, não obstante, o desenvolvimento de competências propiciadas pela experiência da graduação/pós-graduação, na insterseccionalidade com aspectos da cultura e da produção de subjetividades e geração de conhecimento.</p><br/>
      <h4>Linhas de pesquisa:</h4> 
      <ul>
        <li>Pesquisas com os Egressos</li> 
        <li>Pesquisas psicossociais sobre as carreiras</li> 
      </ul>
      <p><strong>Coordenador do grupo: </strong> Sérgio Dias Cirino</p>
      <p><strong>Área predominante:</strong> Ciências Humanas; Psicologia</p>
      <p><strong>Instituição do grupo:</strong> Universidade Federal de Minas Gerais</p>
      <p><strong>Unidade:</strong> Faculdade de Filosofia e Ciências Humanas, Departamento de Psicologia</p>
      <p><strong>Contato do grupo:</strong> alumni.ufmg@gmail.com</p>
      <br/>
    </div>
  </div>
</template>

<script>
import Cabecalho from "@/components/Cabecalho";

export default {
  name: 'Sobre',
  components: {Cabecalho}
}
</script>
